import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Modal from "react-bootstrap/Modal";

import CharacterLimitIndicator from "../reusable/character_limit_indicator";
import { ProductContext } from "../data/product_context_management";
import useProductUpdateApi from "../data/use_product_update_api";
import SaveSpinnerButton from "./save_spinner_button";
import { specificationsMaxLength, productSpecificationsYupSchema } from "../../../yup_schemas/product_schema";

function SpecificationsForm() {
  const context = useContext(ProductContext);
  const { product, isUpdating, setOpenEditModal, setGeneralError } = context;
  const [showSpecifications, setShowSpecifications] = useState(product.page_config?.show_specifications || false);
  const [specificationsLength, setSpecificationsLength] = useState(
    product.subtype_attributes?.specifications?.length || 0,
  );
  const { updateProduct } = useProductUpdateApi({ ...context });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(productSpecificationsYupSchema),
  });

  useEffect(() => {
    setShowSpecifications(product?.page_config?.show_specifications || false);
  }, [product]);

  const handleSpecificationsChange = (event) => {
    setSpecificationsLength(event.target.value.length);
  };

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();

    const submitData = { ...data };
    updateProduct(submitData);
  };

  const handleToggle = () => {
    const updatedShowSpecifications = !showSpecifications;
    setShowSpecifications(updatedShowSpecifications);

    const pageConfig = {
      ...product.page_config,
      show_specifications: updatedShowSpecifications,
    };

    updateProduct({ page_config: pageConfig }, { closeModal: false });
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3 row">
            <div className="col-12">
              <div className="form-check form-switch">
                <label className="form-check-label" htmlFor="show_specifications">
                  Show Specifications?
                  <input
                    checked={showSpecifications}
                    className="form-check-input"
                    disabled={isUpdating}
                    id="show_specifications"
                    type="checkbox"
                    onChange={handleToggle}
                  />
                </label>
              </div>
            </div>
          </div>
          {showSpecifications && (
            <div className="mb-3 row">
              <label htmlFor="overview" className="col-sm-3 col-form-label d-none">
                Specifications
              </label>
              <div className="">
                <textarea
                  id="specifications"
                  className="form-control"
                  rows="3"
                  {...register("subtype_attributes.specifications")}
                  defaultValue={product.subtype_attributes?.specifications}
                  onChange={handleSpecificationsChange}
                  placeholder="Enter specifications here..."
                />
                <div className="mt-2">
                  <CharacterLimitIndicator
                    fieldName="specifications"
                    length={specificationsLength}
                    maxLength={specificationsMaxLength}
                  />
                  {errors?.subtype_attributes?.specifications && (
                    <span className="text-danger">{errors?.subtype_attributes.specifications?.message}</span>
                  )}
                </div>
              </div>
            </div>
          )}
        </form>
      </Modal.Body>
      {showSpecifications && (
        <Modal.Footer>
          <SaveSpinnerButton
            inactiveText="Save"
            activeText="Saving..."
            isSaving={isUpdating}
            className="btn btn-primary"
            onClick={handleSubmit(onSubmit)}
          />
          <button type="button" className="btn btn-link" onClick={closeModal}>
            Cancel
          </button>
        </Modal.Footer>
      )}
    </>
  );
}

export default SpecificationsForm;
